
<h2>Confirmer la modification de ce panier</h2>

<form id="checkPriceForm" [formGroup]="checkPriceForm" autocomplete="off">
  <mat-form-field appearance="outline">
    <mat-label>Indiquez le prix du panier à modifier</mat-label>
    <input matInput type="number" formControlName="price" (input)="checkValue()" autocomplete="off">
  </mat-form-field>

  <fa-icon *ngIf="f.price.value && isCheck" class="faCheck"[icon]="getFaIcon('faCheckCircle')"></fa-icon>
  <fa-icon *ngIf="f.price.value && !isCheck"class="faNoCheck" [icon]="getFaIcon('faTimesCircle')"></fa-icon>

</form>

<div class="btn_action">
  <button type="button"  (click)="dialogRef.close(false)" class="back">Annuler</button>
  <button type="submit" (click)="dialogRef.close(true)" class="confirm" form="checkPriceForm" [disabled]="!isCheck" [style.opacity]="isCheck ? 1 : .5">Activer la modification</button>
</div>